var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useContext, useEffect, useState } from "react";
import { accountDetails } from "@mainDi/salesDi";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { EProductIds, ESubProductIds, ESubProductNames, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { ProductOrderContext } from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ProductOrders/ProductOrdersContext";
import { useNavigate } from "react-router-dom";
export var useOrderBookAlertController = function () {
    var _a = __read(useState({
        visible: false,
        aifCount: 0,
        pmsCount: 0,
    }), 2), counts = _a[0], setCounts = _a[1];
    var viewAllClickCallback = useContext(ProductOrderContext).viewAllClickCallback;
    var navigate = useNavigate();
    useEffect(function () {
        fetchLobDraftAlert();
    }, []);
    var fetchLobDraftAlert = function () { return __awaiter(void 0, void 0, void 0, function () {
        var loginCode, _a, aifRes, pmsRes, aifCount, pmsCount, error_1;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, accountDetails.getUserLoginCode()];
                case 1:
                    loginCode = _d.sent();
                    return [4 /*yield*/, Promise.all([
                            aifPmsDi.qualityCheck.pendingCount({
                                approvalType: "L2",
                                loginCode: loginCode,
                                categoryCode: Number(ESubProductIds.AIF),
                            }),
                            aifPmsDi.qualityCheck.pendingCount({
                                approvalType: "L2",
                                loginCode: loginCode,
                                categoryCode: Number(ESubProductIds.PMS),
                            }),
                        ])];
                case 2:
                    _a = __read.apply(void 0, [_d.sent(), 2]), aifRes = _a[0], pmsRes = _a[1];
                    aifCount = ((_b = aifRes.data) === null || _b === void 0 ? void 0 : _b.mcount) || 0;
                    pmsCount = ((_c = pmsRes.data) === null || _c === void 0 ? void 0 : _c.mcount) || 0;
                    if (aifCount > 0 || pmsCount > 0) {
                        setCounts({
                            visible: true,
                            aifCount: aifCount,
                            pmsCount: pmsCount,
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _d.sent();
                    console.error("Error fetching pending counts:", error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onClickPendingTransactionView = function (subCategoryId) {
        if (subCategoryId === ESubProductIds.AIF) {
            navigate("/dashboard/orderbook", {
                state: { showPendingTransaction: ESubProductNames.AIF },
            });
            viewAllClickCallback(EProductIds.MANAGED_PORTFOLIO, ESubProductIds.AIF);
        }
        else {
            navigate("/dashboard/orderbook", {
                state: { showPendingTransaction: ESubProductNames.PMS },
            });
            viewAllClickCallback(EProductIds.MANAGED_PORTFOLIO, ESubProductIds.PMS);
        }
    };
    return {
        onClickPendingTransactionView: onClickPendingTransactionView,
        counts: counts,
        setCounts: setCounts,
    };
};
